export default "__VITE_ASSET__CpXOMNiH__"